<template>
  <div v-if="isUserAuthenticated()">
    <div v-html="contractHtml"></div>
  </div>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalContract from '@/components/ModalContract.vue'
import APIContract from '@/api/contract'
import APIReport from '@/api/report'
import {router} from '@/router'
const APIContractService = new APIContract();
const APIReportService = new APIReport();
var axios = require('axios')

export default {

  components:
  {
    TemplateAdminComponent
  },

  mounted() {
    // Hide google recaptcha, cause a printing square that hides the email address at the bottom right.
    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        var elem = document.getElementsByClassName("grecaptcha-badge")[0]
        elem.style = "visibility:hidden;";
      }
    }
  },

  data() {
    return {
      contractHtml: ""
    }
  },

  created(){
    this.initialize()
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated();
    },

    logout() {
      auth.logout()
    },

    async initialize () {
      var contractId = this.$route.params.ID
      if (contractId > 0)
      {
        await APIReportService.generateContractHtml(contractId).then(response =>  {
            this.contractHtml += response.data
          }
        )
      }
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/Contract.vue